import { tabsApiConnector } from 'apiConnector/tabs/tabs';
import { ofType } from 'redux-observable';
import { EMPTY } from 'rxjs';
import { catchError, filter, map, mergeMap, withLatestFrom } from 'rxjs/operators';
import type { EpicWithThunk } from 'state/state.common';
import { workspaceTabsPersisted } from 'state/workspaces/workspace.actions';

export function persistBatchWorkspaceTabOnResetCompletedEpic(): EpicWithThunk {
  return (action$, state$, { httpClient, selectors: { getPersistedTabs } }) => {
    return action$.pipe(
      ofType('WORKSPACE_RESET_TAB_COMPLETED'),
      filter(action => action.workspace === 'newBatch'),
      withLatestFrom(state$),
      mergeMap(([, state]) => {
        const tabsDescription = getPersistedTabs(state, 'newBatch');
        return tabsApiConnector(httpClient, 'newBatch')
          .updateTabDescriptions(tabsDescription)
          .pipe(
            map(_ => workspaceTabsPersisted(tabsDescription, 'newBatch')),
            catchError((_: Error) => {
              return EMPTY;
            }),
          );
      }),
    );
  };
}
